module.exports = __webpack_public_path__ + "static/Primary-Composite-1@2x-a7638d1da9a3d546bc6226ab64d60a03.png";